import { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import Container from "../components-layout/Container"
import Layout from "../Layout"
import SearchForm from "../components-contabilidad-analisis/SearchForm"
import Pagination from "../components-contabilidad-analisis/Pagination"
import DatagridCierreCajas from "./DatagridCierreCajas"
import Axios from "axios"
import Cookies from "universal-cookie"
import WarningModal from "../components-modals/WarningModal"

const searchParams = ['Empresa', 'Usuario', 'FechaCorte', 'EfectivoCobrado', 'EfectivoDepositado', 'FechaCuadrado', 'DiasSinCuadrar', 'DiasParaCuadrar', 'Sede']

const sedesIds = (id) => {
    const opcion = {
        '01': () => "Calzada San Juan",
        '02': () => "Avenida Petapa",
        '04': () => "Aguilar Batres",
        '05': () => "Zona 6",
        '06': () => "San Cristóbal",
        '07': () => "Villa Nueva",
        '08': () => "El Naranjo",
        '09': () => "Virtual a Distancia",
        '10': () => "Amatitlán",
        '11': () => "Jocotenango",
    }
    return opcion[id]()
}

const CierreCaja = () => {

    const user = useSelector(state => state.auth.user)
    const userObj = JSON.parse(user)

    const SedePref = useSelector((state) => state.auth.IdSede);

    //Fetch de datos
    const aFecha = new Date()
    const dFecha = new Date(new Date().setDate(aFecha.getDate() - 30))


    const headersApi = useSelector((state) => state.url.headersAPI)
    const cookies = new Cookies()
    const urlSchoolApi = cookies.get('__urlSchoolApi')

    const urlCierreCaja = urlSchoolApi + '/finanzas/getcierrecajadiario'

    const configObj = {
        method: 'GET',
        url: urlCierreCaja,
        headers: headersApi,
        params: '',
    }

    const [loading, setLoading] = useState(false)
    const [rawData, setRawData] = useState([])

    useEffect(() => {
        const initParams = {
            dFecha: dFecha.toLocaleDateString('es-GT').split('/').map(x => x.padStart(2, '0')).reverse().join(''),
            aFecha: aFecha.toLocaleDateString('es-GT').split('/').map(x => x.padStart(2, '0')).reverse().join(''),
            IdSede: window.location.pathname === '/campus/cierre_caja' || window.location.pathname === '/campus/' ? '' : SedePref
        }
        configObj.params = initParams

        const fetchData = async () => {
            try {
                setLoading(true)
                const response = await Axios(configObj)
                setRawData(response.data)
                setLoading(false)
            } catch (err) {
                console.log(err)
            }
        }

        fetchData()

    }, [])

    //Busqueda 
    const [filterData, setFilter] = useState([])
    useEffect(() => { setFilter(rawData) }, [rawData])

    const handleQuery = (values) => {
        doSearch(values.query.trim())
        setCurrentPage(1)
    }

    const doSearch = (query) => {
        if (query === null) {
            setFilter(rawData)
        } else {
            setFilter(rawData.filter((x) => {
                return searchParams.some((y) => {
                    return x[y]?.toString().toLowerCase().indexOf(query.toLowerCase()) > -1
                })
            }))
        }
    }
    //Fin busqueda

    //Paginación
    const [currentPage, setCurrentPage] = useState(1)
    const recordsPerPage = 8

    const indexOfLastRecord = currentPage * recordsPerPage
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage

    const currentRecords = filterData?.slice(indexOfFirstRecord, indexOfLastRecord)

    const nPages = Math.ceil(rawData?.length / recordsPerPage)
    //Fin paginación

    return (
        <Layout userObj={userObj} activeTab='Vistas'>
            <WarningModal
                open={loading ? true : false}
                image={<img src='./img/loader.gif' alt='loading' />}
                opacity='bg-opacity-100'
            />
            <Container height='h-full'>
                <div className="flex flex-col gap-5">
                    <div className="mt-5 lg:mt-0">
                        <SearchForm
                            handleQuery={handleQuery}
                        />
                    </div>
                    <div>
                        <DatagridCierreCajas
                            data={currentRecords}
                            currentPage={currentPage}
                            recordsPerPage={recordsPerPage}
                            dFecha={dFecha.toLocaleDateString('es-GT')}
                            aFecha={aFecha.toLocaleDateString('es-GT')}
                            sede={sedesIds(SedePref)}
                        />
                        <Pagination
                            nPages={nPages}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            totalRecords={filterData?.length}
                            indexOfFirstRecord={indexOfFirstRecord}
                            indexOfLastRecord={indexOfLastRecord}
                        />
                    </div>
                </div>
            </Container>
        </Layout>
    )
}

export default CierreCaja